import React from 'react'
import { staticAsset } from '@js/common/utils'

const MariaChat = ({ message, additionalClassNames = '' }) => {
  if (!message) {
    return null
  }

  return (
    <div
      className={`[ f-d-flr f-m-v-020 f-m-h-auto ] MariaChat ${additionalClassNames}`}>
      <div className='MariaChat-avatar'>
        <img
          className='MariaChat-avatar-img'
          src={staticAsset('images/chat-img.png')}
        />
      </div>
      <div className='[ f-m-l-010 f-m-l-020:m ] MariaChat-message-wrapper'>
        <div className='[ f-pos-rel f-t-body f-c-ba-neu025 f-t-left f-p-a-020 ] MariaChat-message'>
          {message}
        </div>
      </div>
    </div>
  )
}

export default MariaChat
